import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export default function Page404() {

  
  const navigate = useNavigate();

  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "80vh",
      // backgroundColor: "#f3f4f6",
      padding: "16px",
    },
    card: {
      // backgroundColor: "#ffffff",
      borderRadius: "16px",
      // boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.1)",
      padding: "32px",
      maxWidth: "400px",
      width: "100%",
      textAlign: "center",
    },
    iconWrapper: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "16px",
    },
    icon: {
      width: "64px",
      height: "64px",
      color: "#ef4444",
    },
    heading: {
      fontSize: "40px",
      fontWeight: 700,
      color: "#1f2937",
      marginBottom: "8px",
    },
    text: {
      fontSize: "18px",
      color: "#4b5563",
      marginBottom: "24px",
      lineHeight: 1.5,
    },
    button: {
      width: "100%",
      padding: "12px 16px",
      fontSize: "16px",
      fontWeight: 600,
      backgroundColor: "black",
      color: "#ffffff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "background-color 0.2s ease",
    },
  };

  return (
    <div style={styles.container}>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={styles.card}
      >
        <div style={styles.iconWrapper}>
          <AlertTriangle style={styles.icon} />
        </div>
        <h1 style={styles.heading}>404</h1>
        <p style={styles.text}>
          Oops! The page you're looking for doesn't exist.
        </p>
        <button style={styles.button} onClick={() => navigate("/")}>
          Go Home
        </button>
      </motion.div>
    </div>
  );
}
